import {h, Component} from 'preact';
import ReactTelInput from 'react-telephone-input/lib/withStyles';
import CloseButtonWithCircle from '../tags/close-button-with-circle';
import VerificationCode from '../tags/verification-code';
import ResetPasswordRequest from '../../services/resetPasswordRequest';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';

export default class PhoneCodeVerification extends Component {
    constructor() {
        super();
        this.phoneNumber = '';
        this.state = {
            username: null,
            resetPwPhoneInfo: null,
            pageHeader: 'Enter your mobile number',
            subTitle: '',
            step: 'sendCode',
            sendCodeLoading: false,
            sendCodeError: '',
            verificationCode: '',
            continueBtnLoading: false,
            verificationCodeError: '',
            resetVerificationCode: false
        }
    }

    componentDidMount() {
        const username = sessionStorage.getItem(SessionStorageKeys.authUsername);
        const resetPwPhoneInfo = sessionStorage.getItem(SessionStorageKeys.resetPasswordPhoneInfo);
        if (username && resetPwPhoneInfo) {
            this.setState({
                username,
                resetPwPhoneInfo: JSON.parse(resetPwPhoneInfo)[0],
                subTitle: `To reset your password verify your mobile number on file ending in ${JSON.parse(resetPwPhoneInfo)[0].reference}:`
            })
        } else {
            this.props.goToPage('forget-password');
        }
    }

    componentWillUnmount() {
        sessionStorage.removeItem(SessionStorageKeys.authUsername);
        sessionStorage.removeItem(SessionStorageKeys.resetPasswordPhoneInfo);
    }

    onPhoneNumberChange = phoneNumber => {
        this.setState({ sendCodeError: '' });
        this.phoneNumber = phoneNumber;
    };

    onPhoneNumberEnter = e => {
        e.preventDefault();
        this.sendResetPhoneCode();
    };

    sendResetPhoneCode = () => {
        if (this.state.sendCodeLoading) {
            console.log('Loading...');
        } else {
            if (this.phoneNumber.replace(/\D/g, '').length < 6) {
                this.setState({ sendCodeError: 'Please enter your mobile number.' });
            } else {
                this.setState({ sendCodeError: '', sendCodeLoading: true });
                const phoneNumber = `+${this.phoneNumber.replace(/\D/g, '')}`;
                ResetPasswordRequest.sendVerificationCode(this.state.username, phoneNumber)
                    .then(() => {
                        this.setState({
                            pageHeader: 'Enter code',
                            subTitle: 'Enter the verification code we sent to your phone:',
                            step: 'enterCode'
                        });
                    }, error => {
                        this.setState({ sendCodeLoading: false });
                        const errorStatus = error.response.status;
                        if (errorStatus === 400) {
                            this.setState({ sendCodeError: 'This number doesn\'t match what\'s on file.' });
                        } else {
                            this.setState({ sendCodeError: 'Server error, please try later.' });
                        }
                    });
            }
        }
    };

    resendVerificationCode = () => {
        const phoneNumber = `+${this.phoneNumber.replace(/\D/g, '')}`;
        this.setState({ verificationCodeError: '', resetVerificationCode: false });
        ResetPasswordRequest.sendVerificationCode(this.state.username, phoneNumber)
            .then(() => {
                this.setState({ verificationCodeError: 'Please check your phone for the new code.', resetVerificationCode: true });
            }, () => {
                this.setState({ verificationCodeError: 'Server error, please try later.', resetVerificationCode: true });
            });
    };

    autoSubmitVerificationCode = verificationCode => {
        this.setState({ verificationCode });
        this.submitVerificationCode();
    };

    submitVerificationCode = () => {
        if (this.state.continueBtnLoading) {
            console.log('Loading...');
        } else {
            const verificationCode = this.state.verificationCode;
            if (!verificationCode) {
                this.setState({ verificationCodeError: 'Please enter the verification code.' });
            } else {
                this.setState({ verificationCodeError: '', continueBtnLoading: true, resetVerificationCode: false });
                ResetPasswordRequest.checkVerificationCode(verificationCode)
                    .then(() => {
                        this.setState({ continueBtnLoading: false });
                        this.props.setStep('createPassword');
                    }, error => {
                        this.setState({ continueBtnLoading: false, resetVerificationCode: true  });
                        const errorData = error.response.data;
                        const errorStatus = error.response.status;
                        if (errorStatus === 403) {
                            this.setState({ verificationCodeError: 'The verification code is invalid.' });
                        } else {
                            this.setState({ verificationCodeError: errorData.message });
                        }
                    });
            }
        }
    };

    renderPhoneCodeSteps = step => {
        const {defaultCountry, sendCodeLoading, sendCodeError, continueBtnLoading, verificationCodeError,resetVerificationCode} = {...this.state};
        switch (step) {
            case 'sendCode':
                return(
                    <div className='user-phone-number clearfix verification-section'>
                        <form>
                            <div className='phone-number-wrapper'>
                                <div className='clearfix'>
                                    <label htmlFor='phone-number'>Mobile phone number</label>
                                    <ReactTelInput
                                        inputProps={{autoFocus: true}}
                                        defaultCountry={defaultCountry || 'us'}
                                        preferredCountries={['us', 'ru', 'gb', 'au']}
                                        flagsImagePath='img/flags.png'
                                        onChange={this.onPhoneNumberChange}
                                        onEnterKeyPress={this.onPhoneNumberEnter}
                                    />
                                </div>
                                <div className='clearfix'>
                                    <label />
                                    <p><span className={`wi wi-warning error-icon ${sendCodeError ? '' : 'hidden'}`}/>{sendCodeError} &nbsp;</p>
                                </div>
                            </div>
                            <div className='get-help-wrapper clearfix'>
                                <div className='field-label'>
                                    No access to this phone?
                                </div>
                                {this.props.renderHelpLink('', false)}
                            </div>
                        </form>
                        <div className='bottom-buttons clearfix'>
                            <a className={`button-prime button pull-right ${sendCodeLoading ? 'loading' : ''}`}
                               onClick={this.sendResetPhoneCode}
                            >Send code</a>
                        </div>
                    </div>
                );
            case 'enterCode':
                return(
                    <div className='enter-verification-code-section verification-section'>
                        <form className='verification-code'>
                            <div className='row no-gutters'>
                                <label htmlFor='digit0'>Verification code</label>
                                <VerificationCode number={6} callback={this.autoSubmitVerificationCode} reset={resetVerificationCode}/>
                                <a onClick={this.resendVerificationCode} className='resend-code-button'>
                                    Send new code
                                </a>
                            </div>
                            <div className='clearfix'>
                                <label />
                                <span className={`wi wi-warning error-icon ${verificationCodeError ? '' : 'hidden'}`}/>{verificationCodeError} &nbsp;
                            </div>
                        </form>
                        <div className='bottom-buttons clearfix'>
                            <a className={`button-prime button pull-right ${continueBtnLoading ? 'loading' : ''}`}
                               onClick={this.submitVerificationCode}
                            >Continue</a>
                        </div>
                    </div>
                );
        }
    };

    goToLoginPage = () => {
        this.props.goToPage('/');
    };

    render({}, {pageHeader, subTitle, step}) {
        return(
            <div className='form'>
                <h2>{pageHeader} <CloseButtonWithCircle action={this.goToLoginPage}/></h2>
                <p className='sub-title'>{subTitle}</p>
                {this.renderPhoneCodeSteps(step)}
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/scripts/views/reset-password/phone-code-verification.js